module.exports = __webpack_public_path__ + "img/tag-phone.9faa734a.svg";